import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import './TransactionHistory.css';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import OperationList from "../../components/Operations/OperationsList/OperationList";
import { WalletInfoState } from '../../types/types';
import { useAppSelector } from '../../services/redux/hook';


const TransactionHistoryPage: React.FC<any> = () => {

    const { t, i18n } = useTranslation();
    const page = useRef(null);
    const history = useHistory();
    const walletInfo: WalletInfoState = useAppSelector((state) => state.walletInfo);

    const [presentingElement, setPresentingElement] = useState<HTMLElement | null>(null);

    useEffect(() => {
        if (!walletInfo?.account_key) {
            history.replace("/"); // Redirects without keeping history
        }
    }, [walletInfo, history]);

    useEffect(() => {
        setPresentingElement(page.current);
    }, []);


    return (

        <IonPage ref={page}>

            <IonHeader translucent={true} className="ion-no-border">
                <IonToolbar>
                    <IonTitle className="text-3xl font-bold">{t('history.page.header') as string}</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent scrollY={false}>

                <OperationList
                    marginForTransactionList={35}
                />

            </IonContent>

        </IonPage>

    )

}

export default React.memo(TransactionHistoryPage)